import { trackGtmEvent } from '../../analytics/gtm';
import { AUTH_EVENT } from './constants';

const AUTH_EVENT_NAMES = new Set(Object.values(AUTH_EVENT));

/**
 * Record an auth lifecycle event. Unknown names are ignored.
 * Only step and error code are forwarded — never the phone number or OTP.
 *
 * @param {string} eventName
 * @param {{ step?: string, errorCode?: string }} [payload]
 */
export function trackAuthEvent(eventName, payload = {}) {
  if (!AUTH_EVENT_NAMES.has(eventName)) {
    return;
  }

  const safe = {};
  if (payload.step) safe.step = payload.step;
  if (payload.errorCode) safe.error_code = payload.errorCode;
  trackGtmEvent(eventName, safe);
}
